// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CookieConsent_banner__yUJ4n {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, rgba(30, 30, 40, 0.98), rgba(45, 45, 60, 0.98));
  backdrop-filter: blur(10px);
  padding: 1.25rem;
  z-index: 9999;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
  animation: CookieConsent_slideUp__tDzGU 0.4s ease-out;
}

@keyframes CookieConsent_slideUp__tDzGU {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.CookieConsent_content__Geigh {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.CookieConsent_text__lywZU {
  flex: 1 1;
}

.CookieConsent_text__lywZU h3 {
  color: #fff;
  font-family: 'Fredoka', sans-serif;
  font-size: 1.1rem;
  margin: 0 0 0.5rem 0;
}

.CookieConsent_text__lywZU p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
}

.CookieConsent_actions__RXn03 {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}

.CookieConsent_acceptBtn__62ejT,
.CookieConsent_declineBtn__Q1KZy {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: none;
}

.CookieConsent_acceptBtn__62ejT {
  background: linear-gradient(135deg, #ff6b9d, #c44569);
  color: white;
  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.3);
}

.CookieConsent_acceptBtn__62ejT:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 107, 157, 0.4);
}

.CookieConsent_declineBtn__Q1KZy {
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.CookieConsent_declineBtn__Q1KZy:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

/* Mobile responsive */
@media (max-width: 640px) {
  .CookieConsent_banner__yUJ4n {
    padding: 1rem;
  }

  .CookieConsent_content__Geigh {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .CookieConsent_text__lywZU h3 {
    font-size: 1rem;
  }

  .CookieConsent_text__lywZU p {
    font-size: 0.85rem;
  }

  .CookieConsent_actions__RXn03 {
    width: 100%;
    justify-content: center;
  }

  .CookieConsent_acceptBtn__62ejT,
  .CookieConsent_declineBtn__Q1KZy {
    padding: 0.65rem 1.25rem;
    font-size: 0.85rem;
  }
}

/* Reduce motion */
@media (prefers-reduced-motion: reduce) {
  .CookieConsent_banner__yUJ4n {
    animation: none;
  }

  .CookieConsent_acceptBtn__62ejT,
  .CookieConsent_declineBtn__Q1KZy {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CookieConsent.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mFAAmF;EACnF,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,qDAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[".banner {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(135deg, rgba(30, 30, 40, 0.98), rgba(45, 45, 60, 0.98));\n  backdrop-filter: blur(10px);\n  padding: 1.25rem;\n  z-index: 9999;\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);\n  animation: slideUp 0.4s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.text {\n  flex: 1;\n}\n\n.text h3 {\n  color: #fff;\n  font-family: 'Fredoka', sans-serif;\n  font-size: 1.1rem;\n  margin: 0 0 0.5rem 0;\n}\n\n.text p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.acceptBtn,\n.declineBtn {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  border: none;\n}\n\n.acceptBtn {\n  background: linear-gradient(135deg, #ff6b9d, #c44569);\n  color: white;\n  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.3);\n}\n\n.acceptBtn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 107, 157, 0.4);\n}\n\n.declineBtn {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.declineBtn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n/* Mobile responsive */\n@media (max-width: 640px) {\n  .banner {\n    padding: 1rem;\n  }\n\n  .content {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .text h3 {\n    font-size: 1rem;\n  }\n\n  .text p {\n    font-size: 0.85rem;\n  }\n\n  .actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .acceptBtn,\n  .declineBtn {\n    padding: 0.65rem 1.25rem;\n    font-size: 0.85rem;\n  }\n}\n\n/* Reduce motion */\n@media (prefers-reduced-motion: reduce) {\n  .banner {\n    animation: none;\n  }\n\n  .acceptBtn,\n  .declineBtn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `CookieConsent_banner__yUJ4n`,
	"slideUp": `CookieConsent_slideUp__tDzGU`,
	"content": `CookieConsent_content__Geigh`,
	"text": `CookieConsent_text__lywZU`,
	"actions": `CookieConsent_actions__RXn03`,
	"acceptBtn": `CookieConsent_acceptBtn__62ejT`,
	"declineBtn": `CookieConsent_declineBtn__Q1KZy`
};
export default ___CSS_LOADER_EXPORT___;
